export default __webpack_public_path__ + "static/media/Timothy-Adams.c3c2324c.png";